import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-10/12 mx-auto mt-0 lg:px-5" }
const _hoisted_2 = { class: "w-10/12 mx-auto mt-3 lg:px-5" }
const _hoisted_3 = { class: "text-white text-[0.9rem] font-semibold text-right mt-2 lg:px-5" }
const _hoisted_4 = { class: "text-white text-[0.9rem] font-semibold text-center lg:px-5" }

export function render(_ctx, _cache) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_IftaLabel = _resolveComponent("IftaLabel")
  const _component_Password = _resolveComponent("Password")
  const _component_Button = _resolveComponent("Button")
  const _component_Toast = _resolveComponent("Toast")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[7] || (_cache[7] = _createElementVNode("img", {
      src: "https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/head-login.webp",
      alt: "",
      class: "w-60 mx-auto mb-5"
    }, null, -1 /* HOISTED */)),
    _createElementVNode("form", {
      class: "login-popup",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_IftaLabel, null, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              id: "username",
              modelValue: _ctx.form.username.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.username.value) = $event)),
              class: "w-full text-[#f5eded]! bg-[url('https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/bg-input-2.webp')]! bg-size-[100%_100%]! bg-transparent! border-0!",
              invalid: _ctx.form.username.invalid
            }, null, 8 /* PROPS */, ["modelValue", "invalid"]),
            _cache[3] || (_cache[3] = _createElementVNode("label", {
              for: "username",
              class: "text-white! text-[0.8rem]! font-semibold!"
            }, "อีเมลหรือเบอร์โทรศัพท์", -1 /* HOISTED */))
          ]),
          _: 1 /* STABLE */,
          __: [3]
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_IftaLabel, null, {
          default: _withCtx(() => [
            _createVNode(_component_Password, {
              id: "password",
              modelValue: _ctx.form.password.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.form.password.value) = $event)),
              class: "w-full text-[#f5eded]!",
              "input-class": "w-full text-[#f5eded]! bg-[url('https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/bg-input-2.webp')]! bg-size-[100%_100%]! bg-transparent! border-0!",
              invalid: _ctx.form.password.invalid,
              toggleMask: "",
              feedback: false
            }, null, 8 /* PROPS */, ["modelValue", "invalid"]),
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              for: "password",
              class: "text-white! text-[0.8rem]! font-semibold!"
            }, "รหัสผ่าน", -1 /* HOISTED */))
          ]),
          _: 1 /* STABLE */,
          __: [4]
        })
      ]),
      _createElementVNode("p", _hoisted_3, [
        _cache[5] || (_cache[5] = _createTextVNode(" ลืมรหัสผ่าน ")),
        _createVNode(_component_Button, {
          label: "คลิก",
          onClick: _ctx.clickBtnForgotPassword,
          class: "text-[0.9rem] text-[#16f7ad]! underline !py-0 !px-1 bg-transparent! border-transparent!",
          variant: "text"
        }, null, 8 /* PROPS */, ["onClick"])
      ]),
      _createElementVNode("p", _hoisted_4, [
        _cache[6] || (_cache[6] = _createTextVNode(" ยังไม่มีบัญชีผู้ใช้งาน ")),
        _createVNode(_component_Button, {
          label: "สมัคร",
          onClick: _ctx.btnClickRegister,
          class: "text-[0.9rem] text-[#16f7ad]! underline !py-0 !px-1 bg-transparent! border-transparent!",
          variant: "text"
        }, null, 8 /* PROPS */, ["onClick"])
      ]),
      _createVNode(_component_Button, {
        label: "เข้าสู่ระบบ",
        type: "submit",
        class: "min-w-20 mt-5 bg-[url('https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/botton%20toswebp.webp')]! bg-size-[100%_100%]! bg-transparent! border-transparent!",
        loading: _ctx.form.btn.loading,
        disabled: _ctx.form.btn.disabled
      }, null, 8 /* PROPS */, ["loading", "disabled"])
    ], 32 /* NEED_HYDRATION */),
    _createVNode(_component_Toast)
  ], 64 /* STABLE_FRAGMENT */))
}